// extracted by mini-css-extract-plugin
module.exports = {"label":"Textarea_label__2XxUQ","textarea":"Textarea_textarea__9nxP1","error":"Textarea_error__3VENt"};